import { connect } from 'react-redux'
import ForgotPasswordModalComponent from '../components/ForgotPassword'
import {
  resetForgetPwdForm,
  updateCustomerForgotPasswordEmailField,
} from '../actions/index'
import { sendMeResetPasswordInstructions, getUsersDefaultEmail } from '../actions/apiRequest'
import '../styles/ForgotPassword.scss'

const mapStateToProps = (state) => ({
  ...state.forgotPassword,
})

const mapDispatchToProps = (dispatch) => ({
  onChangeEmail: (e) => {
    const email = e.target.value
    dispatch(updateCustomerForgotPasswordEmailField(email))
  },
  onSendInstructions: (captcha) => {
    dispatch(sendMeResetPasswordInstructions(captcha))
  },
  onUnmount: () => {
    dispatch(resetForgetPwdForm())
  },
  populateDefaultEmail: () => {
    dispatch(getUsersDefaultEmail())
  },
})

const ForgotPassword = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordModalComponent)

export default ForgotPassword
